import { connect } from 'react-redux';

import {
  setQuestionNotification,
  setSwitchPfeSktAction,
} from '../actions/accountSettingsAction';
import { activateSubscription } from '../actions/manageSubscriptionActions';
import {
  buildChapterStudyPlan,
  getAvailableChapters,
  loadChapterStudyPlan,
  saveSelectedChapters,
} from '../actions/personalizedStudyActions';
import {
  getAudioPlaylist,
  getAudioPlaylistsProgress,
  getPdfByReference,
  setBackTo,
  setChapterId,
  setIsStudyFavoriteQuestion,
  setIsStudyingMyFavoriteQuestions,
  setIsStudyingMySubmittedQuestions,
  setIsStudyingSubmittedQuestions,
  updateAudioPlaylistProgress,
  updateDisabledChapter,
} from '../actions/studyMainActions';
import {
  getSwitchPfeSkt,
  getUserSubscription,
} from '../components/AccountSettings/AccountSettingsSelectors';
import {
  getSubscriptionActivationMessage,
  getSubscriptionActivationSuccess,
  getSubscriptionActivationWaiting,
} from '../components/ManageSubscription/ManageSubscriptionSelectors';
import {
  getAvailableChaptersLoadingSelector,
  getAvailableChaptersSelector,
  getBuildChapterStudyPlanLoadingSelector,
  getChapterStudyPlanSelector,
  getSaveChaptersLoadingSelector,
} from '../components/Study/PersonalizedStudy/personalizedStudySelectors';
import PersonalizedStudyView from '../components/Study/PersonalizedStudy/PersonalizedStudyView';
import {
  getAudioPlaylistSelector,
  getAudioPlaylistsProgressSelector,
  getPdfLink,
} from '../components/Study/studyMainSelectors';
import { getUser } from '../components/User/userSelectors';

const mapStateToProps = (state) => ({
  availableChapters: getAvailableChaptersSelector(state),
  availableChaptersLoading: getAvailableChaptersLoadingSelector(state),
  saveChaptersLoading: getSaveChaptersLoadingSelector(state),
  chapterStudyPlan: getChapterStudyPlanSelector(state),
  buildChapterStudyPlanLoading: getBuildChapterStudyPlanLoadingSelector(state),
  user: getUser(state),
  pfeSktId: getSwitchPfeSkt(state),
  userSubscription: getUserSubscription(state),
  subscriptionActivationMessage: getSubscriptionActivationMessage(state),
  subscriptionActivationWaiting: getSubscriptionActivationWaiting(state),
  subscriptionActivationSucces: getSubscriptionActivationSuccess(state),
  pdfLink: getPdfLink(state),
  audioPlaylist: getAudioPlaylistSelector(state),
  audioPlaylistsProgress: getAudioPlaylistsProgressSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  setBackTo: (backTo) => dispatch(setBackTo(backTo)),
  setSwitchPfeSkt: (id) => dispatch(setSwitchPfeSktAction(id)),
  setChapterId: (chapterId) => dispatch(setChapterId(chapterId)),
  setQuestionNotification: (id, idType) =>
    dispatch(setQuestionNotification(id, idType)),
  activateSubscription: () => dispatch(activateSubscription()),
  getPdfByReference: (payload) => dispatch(getPdfByReference(payload)),
  setIsStudyingSubmittedQuestions: (status) =>
    dispatch(setIsStudyingSubmittedQuestions(status)),
  setIsStudyingFavoriteQuestions: (status) =>
    dispatch(setIsStudyFavoriteQuestion(status)),
  setIsStudyingMyFavoriteQuestions: (status) =>
    dispatch(setIsStudyingMyFavoriteQuestions(status)),
  setIsStudyingMySubmittedQuestions: (status) =>
    dispatch(setIsStudyingMySubmittedQuestions(status)),
  updateDisabledChapter: (chapterId, id) =>
    dispatch(updateDisabledChapter(chapterId, id)),
  getAudioPlaylist: (chapterId) => dispatch(getAudioPlaylist(chapterId)),
  getAudioPlaylistsProgress: (chapterIds) =>
    dispatch(getAudioPlaylistsProgress(chapterIds)),
  updateAudioPlaylistProgress: (
    chapterId,
    nextQuestionId,
    status,
    restartPlaylist,
  ) =>
    dispatch(
      updateAudioPlaylistProgress(
        chapterId,
        nextQuestionId,
        status,
        restartPlaylist,
      ),
    ),
  getAvailableChapters: (rate) => dispatch(getAvailableChapters(rate)),
  saveSelectedChapters: (chapters) => dispatch(saveSelectedChapters(chapters)),
  buildChapterStudyPlan: (startDate, examDate) =>
    dispatch(buildChapterStudyPlan(startDate, examDate)),
  loadChapterStudyPlan: () => dispatch(loadChapterStudyPlan()),
});

const PersonalizedStudyContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(PersonalizedStudyView);

export default PersonalizedStudyContainer;
